// TODO: Fix no-non-null assertions
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import cx from 'classnames'
import styles from './GithubCard.module.scss'
import { PullResponse } from './types'
import { githubPullIcon, parseDate } from './common'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { ReactComponent as CommentsIcon } from './icons/comments.svg'
import { ReactComponent as ArrowRight } from 'assets/icons/arrowRight24.svg'
import { ReactComponent as GithubLogo } from 'assets/icons/logos/github24.svg'
import { StrongNode, nodes } from 'prose-core'
import { AnchorOrDiv, Skel } from '../EmbedCommon/common'

dayjs.extend(relativeTime)

export type GithubCardProps = {
  node: StrongNode<typeof nodes.github_embed>
  isLoading: boolean
  status: 'merged' | 'open' | 'open-issue' | 'closed' | 'closed-issue' | 'draft'
  data: PullResponse
  preview?: true
}
export const GithubCard = (props: GithubCardProps) => {
  const { node, isLoading, status, data, preview } = props
  if (isLoading)
    return (
      <div className={cx(styles.card, styles.isLoading)}>
        <div className={styles.icon}>
          <GithubLogo width={32} height={32} />
        </div>
        <div className={styles.body}>
          <Skel />
          <Skel width={'50%'} />
        </div>
      </div>
    )
  return (
    <div className={cx(styles.pull, styles[node.attrs.mode])}>
      <div className={cx(styles.icon, styles[status])}>{githubPullIcon(status)}</div>

      <AnchorOrDiv link={preview ? undefined : node?.attrs.link} className={styles.title}>
        {data?.title}
        {data?.labels?.map((label) => (
          <div
            className={styles.label}
            key={label.name}
            style={{
              color: `#${label.color}`,
              borderColor: `#${label.color}4C`,
              backgroundColor: `#${label.color}2D`,
            }}
          >
            {label.name}
          </div>
        ))}
      </AnchorOrDiv>
      <div className={styles.meta}>
        {
          <>
            {(() => {
              switch (status) {
                case 'draft':
                case 'open-issue':
                case 'closed-issue': // as of this message, github renders "opened at" for closed issues
                case 'open':
                  return (
                    <>
                      #{data?.number ?? '?'} opened{' '}
                      <span title={data?.created_at && dayjs(parseDate(data?.created_at)).format()}>
                        {dayjs(parseDate(data?.created_at)).fromNow()}
                      </span>{' '}
                      by {data?.user?.login}
                    </>
                  )
                case 'merged':
                  return (
                    <>
                      #{data?.number ?? '?'} merged{' '}
                      <span title={data?.created_at && dayjs(parseDate(data?.created_at)).format()}>
                        {dayjs(parseDate(data?.created_at ?? null)).fromNow()}
                      </span>{' '}
                      by ${data?.user?.login}
                    </>
                  )

                case 'closed':
                  return (
                    <>
                      #{data!.number} closed{' '}
                      <span title={data?.closed_at && dayjs(parseDate(data?.closed_at)).format()}>
                        {dayjs(parseDate(data?.closed_at ?? null)).fromNow()}
                      </span>{' '}
                      by {data?.user?.login}
                    </>
                  )
              }
            })()}
            {data?.comments > 0 && (
              <>
                <CommentsIcon className={styles.commentsIcon} width={16} />{' '}
                <span className={styles.commentsNumber}>{data?.comments}</span>
              </>
            )}
          </>
        }
      </div>

      <AnchorOrDiv link={preview ? undefined : node?.attrs.link} className={styles.button}>
        <ArrowRight />
      </AnchorOrDiv>
    </div>
  )
}
